// extracted by mini-css-extract-plugin
module.exports = {"gallery":"gallery-module--gallery--6VVDj","navImage":"gallery-module--nav-image--3e500","imgContainer":"gallery-module--img-container--7kNjI"};